<template>
    <div>
        <b-row>
            <b-col>
                <h5>
                    <span
                        @click="hasHistory()
                        ? $router.go(-1)
                        : $router.push('/')"
                        class="button-come-back mr-2"><i class="fas fa-angle-left"></i>
                    </span> Заказ #{{order_id}}
                    <template v-if="items.text_mark">
                        <span class="font-size-14">{{ items.text_mark }}</span>
                    </template>
                </h5>
            </b-col>
        </b-row>
        <div class="mt-4 position-relative">
            <tsoft-order-show-one
                v-if="!dataOverlay"
                :detailedItem="detailedItem"
                @closeOrder="closeOrderByID"
                @changeOrderStatus="changeOrderStatus"
                @changeOrderStatusByID="changeOrderStatusByID"
                @changeCreatorUserId="changeCreatorUserId"
            ></tsoft-order-show-one>
            <b-overlay
                :show="dataOverlay"
                spinner-variant="success"
                no-wrap
            ></b-overlay>
        </div>
    </div>
</template>

<script>
    import {API_ORDERS} from "../constants"
    import tsoftOrderShowOne from '../components/orders/OrderShowOne'

    import {
        orderMethods
    } from '../mixins'

    export default {
        mixins: [
            orderMethods
        ],
        components: {
            'tsoft-order-show-one': tsoftOrderShowOne
        },
        data() {
            return {
                dataOverlay: true,
                tableApiUrl: API_ORDERS,
                order_id: '',
                detailedItem: {},
                componentRefreshKey: 0
            }
        },
        created() {
            this.loadOneOrder()
        },
        watch: {
            $route(to, from) {
                this.loadOneOrder()
            },
        },
        methods: {
            closeOrderByID(id) {
            },
            changeOrderStatus(index, newStatus = 361) {
                if (index == -1 && this.detailedItem.id) {
                    this.changeOrderStatusByID(this.detailedItem.id, newStatus)
                } else {
                    this.$emit('changeOrderStatus', index, newStatus)
                }
            },
            changeOrderStatusByID(id, newStatus = 361) {
                this.dataOverlay = true
                this.updateAnyOrder(id, {
                    reference_status_id: newStatus
                }).then(() => {
                    this.loadOneOrder()
                })
            },
            changeCreatorUserId(id, data, index) {
                this.dataOverlay = true
                this.updateAnyOrder(id, data, index).then(() => {
                    this.loadOneOrder()
                })
            },
            loadOneOrder() {
                this.dataOverlay = true
                if (this.$route.params.order_id) {
                    this.order_id = this.$route.params.order_id

                    api.call("get", `${this.tableApiUrl}/${this.order_id}`).then(({data}) => {
                        this.detailedItem = data
                        this.componentRefreshKey += 1
                        this.dataOverlay = false
                    })
                }
            },
            hasHistory () {
                return window.history.length > 2
            },
        }
    }
</script>
